/**
 * Admin emergency-lead queue (M15-T05 + T06). amtc_admin only. A separate module
 * from the other leads — different endpoint and fields (caller/patient, location,
 * `phone_verified`). These leads are UNVERIFIED (no OTP, ADR-0035).
 */
import { apiFetch, type CappedList } from './client'

export type AdminEmergencyLead = {
  id: string
  reference: string
  emergency_type: string
  caller_name: string | null
  caller_phone: string | null
  patient_name: string | null
  patient_age: number | null
  patient_conscious: string | null
  description: string | null
  location_text: string | null
  phone_verified: boolean
  status: string
  concierge_notes: string | null
  /** Outcome (M15-T10): the ER engaged + the action taken. Null until the
   * patient reaches the what-next step. */
  hospital_name?: string | null
  disposition?: string | null
  created_at: string
  /** Set once the 90-day deletion has cleared the personal details (M37-T02). */
  purged_at?: string | null
}

export const EMERGENCY_LEADS_KEY = ['admin', 'emergency-requests'] as const

/** GET /api/v1/admin/emergency-requests — newest first, optional ?status=. */
export async function fetchEmergencyLeads(
  token: string | null,
  status?: string | null,
  q?: string,
): Promise<CappedList<AdminEmergencyLead>> {
  const params = new URLSearchParams()
  if (status) params.set('status', status)
  if (q) params.set('q', q)
  const qs = params.toString() ? `?${params.toString()}` : ''
  return await apiFetch<CappedList<AdminEmergencyLead>>(
    `/api/v1/admin/emergency-requests${qs}`,
    { token },
  )
}
